(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["saraj-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saraj-read-more')) {
    customElements.define(
      'saraj-read-more',
      class SarajReadMore extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.saraj-read-more__content');
          this.toggle = this.querySelector('.saraj-read-more__toggle');
          if (!this.content || !this.toggle) return;

          this.toggle.addEventListener('click', () => this.setExpanded(!this.classList.contains('is-expanded')));
          // Fonts and images can change the height after first paint
          this.resizeObserver = new ResizeObserver(() => this.updateToggle());
          this.resizeObserver.observe(this.content);
          this.updateToggle();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        /** Show the toggle only when the clipped text is actually cut off. */
        updateToggle() {
          if (this.classList.contains('is-expanded')) return;
          this.toggle.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
        }

        setExpanded(expanded) {
          this.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.querySelector('[data-more]').hidden = expanded;
          this.toggle.querySelector('[data-less]').hidden = !expanded;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["saraj-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saraj-share')) {
    customElements.define(
      'saraj-share',
      class SarajShare extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          button?.addEventListener('click', () => {
            // Replay the press pulse on every click
            button.classList.remove('is-pressed');
            void button.offsetWidth;
            button.classList.add('is-pressed');
            this.share();
          });
        }

        async share() {
          const { url, title } = this.dataset;
          if (navigator.share) {
            try {
              await navigator.share({ title, url });
            } catch {
              // Closing the share sheet rejects; nothing to do
            }
            return;
          }

          try {
            await navigator.clipboard.writeText(url);
            this.showCopied();
          } catch {
            window.prompt('', url);
          }
        }

        showCopied() {
          this.classList.add('is-copied');
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => this.classList.remove('is-copied'), 2000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
